<template>
  <div class="conversion-wrapper">
    <div class="header">
      {{ $t('account.index.currencySettings.faq.widget.title') }}
    </div>
    <div class="view-faq" @click="openSideBar">
      {{ $t('account.index.currencySettings.faq.widget.button') }}
      <b-icon-chevron-right class="color-noble-blue-500 ml-2" scale="1.2" />
    </div>
    <b-sidebar
      id="faq-sidebar-right"
      width="60%"
      right
      shadow
      no-header
      backdrop
      v-model="isSideBarOpen"
      class="sidebar-wrapper"
    >
      <faq />
    </b-sidebar>
  </div>
</template>
<script>
import Faq from '@/components/account/CurrencySettings/FAQ'

export default {
  props: {
    rate: String,
    isFulfilled: Boolean
  },
  data() {
    return {
      isSideBarOpen: false
    }
  },
  components: {
    Faq
  },
  methods: {
    openSideBar() {
      this.$mpTrack('Clicks on "FAQs" on the currency settings page')
      this.isSideBarOpen = true
    }
  }
}
</script>
<style lang="scss">
#faq-sidebar-right {
  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_palette.scss';

.conversion-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: $sky-blue-50;
  padding: 12px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  .header {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: $noble-blue-500;
    margin-bottom: 16px;
    text-align: left;
  }
  .sidebar-wrapper {
    .b-sidebar-body {
      background: $white;
    }
  }
  .view-faq {
    display: flex;
    justify-content: space-between;
    background: $noble-blue-50;
    border: 1px solid $noble-blue-200;
    border-radius: 8px;
    padding: 16px;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: $noble-blue-500;
  }
}
</style>
